"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var StyledModalHeader = (0, _styledComponents["default"])(_reactstrap.ModalHeader)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 16px 16px 0px 16px;\n  border-bottom: none;\n  h5 {\n    font-weight: 600;\n    font-size: 28px;\n    color: #33373d;\n  }\n"])));
var _default = exports["default"] = StyledModalHeader;